import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Nurse-focused landing page — shown instead of the full sonographer
 * WorksheetSelection grid when the user's profession_role is 'nurse'.
 * Keeps a link back to the full worksheet grid since a nurse who's also
 * credentialed to review ultrasound worksheets shouldn't be locked out.
 */
function LungScreeningSelection() {
  const navigate = useNavigate();
  return (
    <div className="worksheet-selection">
      <h2>Nurse Intake</h2>

      <div className="worksheet-section">
        <h3 className="section-title">Screening</h3>
        <div className="worksheet-cards">
          <div role="button" tabIndex={0} className="worksheet-card" onClick={() => navigate('/forms/lung-screening')}>
            <div className="worksheet-icon worksheet-icon-text">CT</div>
            <h3>Lung Cancer Screening Intake</h3>
          </div>
        </div>
      </div>

      <p className="landing-view-switch">
        Need an ultrasound worksheet instead?{' '}
        <button type="button" className="link-button" onClick={() => navigate('/worksheets')}>
          View Ultrasound Worksheets
        </button>
      </p>
    </div>
  );
}

export default LungScreeningSelection;
